import { observable } from 'mobx'
import LocalizationStore from './LocalizationStore'

export interface INotificationEntity {
    type: 'danger' | 'warning' | 'success' | 'info',
    message: string
    isOpen: boolean,
    timeout?: number
}

export class NotificationEntity {
    type: 'danger' | 'warning' | 'success' | 'info'
    message: string
    isOpen: boolean
    timeout?: number

    constructor(type: 'danger' | 'warning' | 'success' | 'info', msg: string, opened?: boolean, time?: number) {
        this.type = type
        this.message = LocalizationStore.getInstance().t(msg)
        this.isOpen = Boolean(opened)
        this.timeout = time
    }
}

export default class NotificationsStore {

    @observable
    private list: Array<INotificationEntity>

    private static _instance: NotificationsStore

    private constructor() {
        this.list = []
    }

    public static getInstance(): NotificationsStore {
        return this._instance || (this._instance = new this())
    }

    addAlert(alert: INotificationEntity) {
        this.list.push(alert)
    }

    setList(list: Array<INotificationEntity>): void {
        this.list = list

        for (let i = 0; i < this.list.length; ++i) {
            setTimeout(
                () => { this.removeAlert(i) },
                this.list[i].timeout ? this.list[i].timeout : 4000
            )
        }

        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }

    getList(): Array<INotificationEntity> {
        return this.list
    }

    removeAlert(alertIndex: Number): void {
        let self = this
        self.list.forEach((item, index) => {
            if (index === alertIndex) {
                self.list.splice(index, 1)
            }
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Stores/NotificationsStore.ts